<template>
  <div class="sustainability">
    <p class="text">
      We want Rat & Boa to be a label that we can be proud of in every way
      possible. With that in mind, we’re making a promise: we want to design and
      create the clothes you love with minimal environmental impact, and
      positive social consequences.
    </p>
    <ul v-if="items.length > 0" class="sustainability__items">
      <li v-for="item in items" :key="item" class="sustainability__item">
        <img
          :src="item.smallImage"
          :alt="item.text"
          class="sustainability__image"
        />
        {{ item.text }}
      </li>
    </ul>
    <Button tag="a" href="/pages/sustainability" form="underline">
      Find out more
    </Button>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { unwrapNodes } from "@/helpers/graphql";
import Button from "@/components/ButtonV2.vue";

export default {
  name: "Sustainability",
  components: {
    Button,
  },
  computed: {
    ...mapState("product", ["product"]),
    references() {
      return unwrapNodes(this.product.sustainability?.references?.edges) || [];
    },
    items() {
      let items = this.references;

      items = items.map((item) => {
        const fields = item.fields;
        const newItem = {
          text: fields.find((field) => field.key === "text").value,
        };

        const mediaField = fields.find(
          (field) =>
            field.reference &&
            field.reference.image &&
            field.reference.image.smallMedia
        );
        if (mediaField) {
          newItem.smallImage = mediaField.reference.image.smallMedia;
        }

        return newItem;
      });

      return items;
    },
  },
};
</script>

<style lang="scss" scoped>
.text {
  @include editorial-body(16px);
  margin-bottom: 24px;
  @include respond-above(md) {
    font-size: 20px;
  }
}

.images {
  display: flex;
  overflow-x: auto;
  flex-flow: row nowrap;
  margin-bottom: 24px;

  & > * {
    flex: 1 0 auto;
    max-width: 250px;
  }
}

.sustainability {
  &__items {
    margin: 0 0 20px 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__item {
    @include utility-body(14px);
    display: flex;
    align-items: center;
    color: $color-grey-dark;
    gap: 16px;
    padding: 0;
  }

  &__image {
    width: 60px;
    height: 60px;
    object-fit: contain;
    border-radius: 50%;
  }
}
</style>
